import { Component } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-user-no-access-dialog',
  templateUrl: './user-no-access-dialog.component.html',
  styleUrl: './user-no-access-dialog.component.scss',
  standalone: true,
  imports: [MatDialogModule, TranslateModule]
})
export class UserNoAccessDialogComponent {}
